import React, { PropTypes, Component } from 'react';
import RenderingUtils from '../utils/rendering';
import classnames from 'classnames';

export function createControlWithLabel(ControlComponent) {
  class ControlWithLabel extends Component {

    componentWillMount() {
      this.backupId = RenderingUtils.uniqueId('control-with-label');
    }

    render() {
      const {
        className,
        placement,
        id = this.backupId,
        children,
        ...passedProps,
      } = this.props;

      const classes = classnames('ControlWithLabel', className, {
        'ControlWithLabel--reverseOrder': placement === 'right',
      });

      return (
        <div className={ classes }>
          <ControlComponent { ...passedProps } id={ id } />
          <label className="ControlWithLabel-content" htmlFor={ id }>
            { children }
          </label>
        </div>
      );
    }
  }
  ControlWithLabel.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    placement: PropTypes.oneOf(['left', 'right']),
    id: PropTypes.string,
  };
  ControlWithLabel.defaultProps = {
    placement: 'left',
  };

  return ControlWithLabel;
}

import RadioButton from './radio-button.react';
export const RadioWithLabel = createControlWithLabel(RadioButton);

import Checkbox from './checkbox.react';
export const CheckboxWithLabel = createControlWithLabel(Checkbox);
